/* src/app/shared-module/components/skeleton-components/skeleton-builder-project/skeleton-builder-project.component.scss */
/*# sourceMappingURL=skeleton-builder-project.component.css.map */
